<template>
    <div>
        <div class="listingPageTitle">
            <h1>Question Maintenance</h1>
            <ItemModal :itemName="'Question'"
                            :formRows="newItemFormRows"
                            :saveItemFunction="saveRecord"
                            :refreshItemsFunction="loadRecords"></ItemModal>
        </div>
        <div class="searchContainer">
            <div class="formRow">
                <span class="inputTitle">Search Question Text: </span>
                <input type="text" v-model="searchText" />
            </div>
            <div class="formRow">
                <span class="inputTitle">Question Type</span>
                <select v-model="searchQuestionType">
                    <option></option>
                    <option v-for="questionType in questionTypes" :key="questionType.value" :value="questionType.internalName" >{{questionType.displayName}}</option>
                </select>
            </div>
            <div class="formRow"><span class="inputTitle">Active Only: </span><input type="checkbox" v-model="onlyShowActive" /></div>
        </div>
        <hr />
        <ListingTable :columns="columns" :filterCriteria="filterCriteria" :actions="actionMappings" 
            :key="componentKey" :intitializationParameters="{ sortBy: 'id', sortDirection: 'desc' }" />
    </div>
</template>

<script>
import { data } from '../../shared/data';
import ItemModal from '@/components/ItemModal.vue';
import ListingTable from '@/components/shared/ListingTable.vue';
import {sorting} from '@/shared/sorting';

export default {
    name: 'QuestionListing',
    components: { ItemModal, ListingTable },
    data: function() {
        return {
            questions: [],
            questionTypes: [],
            answerTypes: [],
            searchText: '',
            onlyShowActive: true,
            componentKey: 0,
            searchQuestionType: '',
            columns: [ 
                {
                    headerDisplayName: "ID",
                    width: "5%",
                    fieldName: "id",
                    isEditLink: true
                },
                {
                    headerDisplayName: "Question Type",
                    width: "15%",
                    fieldName: "questionType"
                },
                {
                    headerDisplayName: "Answer Type",
                    width: "15%",
                    fieldName: "answerType"
                },
                {
                    headerDisplayName: "Description",
                    width: "25%",
                    fieldName: "description",
                    isEditLink: true
                },
                {
                    headerDisplayName: "Text",
                    width: "25%",
                    fieldName: "questionText"
                },
                {
                    width: "10%",
                    columnType: "buttons",
                    showDeleteFieldName: "isActive",
                    showUndeleteFieldName: "!isActive"
                }
            ],
            newItemFormRows: [
                {
                    name: 'Question Text',
                    propertyName: 'questionText',
                    required: {
                        propertyName: 'questionType',
                        value: 'MediaDisplay',
                        equals: false
                    },
                    element: 'textarea',
                    maxLength: 400
                },
                {
                    name: 'Question Type',
                    propertyName: 'questionType',
                    required: true,
                    element: 'select'
                },
                {
                    name: 'Answer Type',
                    propertyName: 'answerType',
                    required: true,
                    element: 'select'
                },
                {
                    name: 'Description',
                    propertyName: 'description',
                    element: 'textarea'
                }
            ],
            actionMappings: {
                onLoadData: this.loadRecords,
                onDelete: this.deleteRecord, 
                onUndelete: this.reactivateRecord,
                editHrefBuilder: this.editHrefBuilder
            },
        }
    },
    mounted() {
        this.getQuestionTypes();
        this.getAnswerTypes();
    },
    computed: {
        filterCriteria () {
            var criteria = [];
            if(this.searchText != "") 
                criteria.push( {
                    dataType: "MultiString",
                    fieldNames: ["questionText", "description"],
                    value: this.searchText
                });

            if(this.onlyShowActive) {
                criteria.push( {
                    dataType: "Boolean",
                    fieldName: "isActive",
                    value: true
                });
            }

            if(this.searchQuestionType) {
                criteria.push( {
                    dataType: "String",
                    fieldName: "questionType",
                    value: this.searchQuestionType
                });
            }


            return criteria;
        }
    },
    methods: {
        loadRecords: async function() {
            return await data.getAllQuestions(false);
        },
        getQuestionTypes: async function() {
            this.questionTypes = await data.getEnumList("QuestionTypes");
            this.questionTypes = this.questionTypes.filter(search => search.internalName != "NotSet");
            this.questionTypes = sorting.sortArray(this.questionTypes, "displayName", "asc", 0, 0);            
            this.newItemFormRows.find(row => row.propertyName == 'questionType').selectOptions = this.questionTypes;
        },
        getAnswerTypes: async function() {
            this.answerTypes = await data.getEnumList("AnswerTypes");
            this.newItemFormRows.find(row => row.propertyName == 'answerType').selectOptions = this.answerTypes;
        },
        editHrefBuilder: function(ques) {
            return '/QuestionEdit?ID=' + ques.id;
        },
        deleteRecord: async function(ques) {
            if(confirm('Are you sure you want to delete this question?')) {
                var status = this.processDeactivateResult(await data.deleteQuestion(ques.id));
                if(status.success) 
                    ques.isActive = false;
            }
        },
        saveRecord: async function(ques) {
            ques.languages = ['English'];
            ques.defaultLanguage = 'English';
            ques.questionTextJson =
                [{
                    text: ques.questionText,
                    language: 'English'
                }];
            return await this.saveQuestion(ques, true);
        },
        saveQuestion: async function(ques, redirectToEditFlag) {
            var retObject = this.processSaveResult(await data.saveQuestion(ques));

            if(retObject.success) {
                if(redirectToEditFlag && retObject.id) {
                    ques.id = retObject.id;
                    window.location.href = this.editHrefBuilder(ques);
                }
                else 
                    return retObject;
            }
            else
                return retObject;
        },
        reactivateRecord: async function(ques) {
            ques.isActive = true;
            var status = await this.saveQuestion(ques);
            if(!status.success)
                ques.isActive = false;
        }
    }
}
</script>

<style scoped>
    .searchContainer {
        text-align: left;
        margin: 20px 50px 25px;
    }
    .searchContainer .formRow {
        margin: 0px 0;
        padding-left: 25px;
        flex-direction: column;
        align-items: start;
        
    }

    .searchContainer .formRow input[type="text"] {
        padding: 4px 10px 5px;
        height: unset;
    }

    .inputTitle {
        padding-right: 15px;
       
    }
    .searchContainer button {
        height: 40px;
        width: 250px;
        border-radius: 5px;
        border-color: rgb(239, 239, 239);
        font-size: 16px;
        cursor: pointer;
    }
</style>